import { AiFillYoutube, AiFillFacebook, AiFillInstagram } from "react-icons/ai";
import { BsTwitch } from "react-icons/bs";
import { FaTiktok } from "react-icons/fa";

const SOCIAL_MEDIA_NAV = [
  {
    name: "Youtube",
    icon: <AiFillYoutube />,
    to: "https://www.youtube.com/@elsewaregames",
  },
  {
    name: "Facebook",
    icon: <AiFillFacebook />,
    to: "https://www.facebook.com/people/Elseware-Games/100065601638760/",
  },
  {
    name: "Instagram",
    icon: <AiFillInstagram />,
    to: "https://www.instagram.com/elsewaregames/",
  },
  {
    name: "TikTok",
    icon: <FaTiktok />,
    to: "https://www.tiktok.com/@elsewaregames",
  },
  {
    name: "Twitch",
    icon: <BsTwitch />,
    to: "https://www.twitch.tv/elsewaregames",
  },
];

export default SOCIAL_MEDIA_NAV;
